import _asyncToGenerator from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/opt/build/repo/node_modules/@babel/runtime/regenerator/index.js";
import { SESSION_IDLE_DURATION } from '../constants.js';

/**
 * Add an event to the event buffer
 */
function addEvent(_x, _x2, _x3) {
  return _addEvent.apply(this, arguments);
}
function _addEvent() {
  _addEvent = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(replay, event, isCheckout) {
    var isMs, timestampInMs, earliestEvent;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (replay.eventBuffer) {
              _context.next = 2;
              break;
            }
            return _context.abrupt("return", null);
          case 2:
            if (!replay.isPaused()) {
              _context.next = 4;
              break;
            }
            return _context.abrupt("return", null);
          case 4:
            // TODO: sadness -- we will want to normalize timestamps to be in ms -
            // requires coordination with frontend
            isMs = event.timestamp > 9999999999;
            timestampInMs = isMs ? event.timestamp : event.timestamp * 1000; // Throw out events that happen more than 5 minutes ago. This can happen if
            // page has been left open and idle for a long period of time and user
            // comes back to trigger a new session. The performance entries rely on
            // `performance.timeOrigin`, which is when the page first opened.
            if (!(timestampInMs + SESSION_IDLE_DURATION < new Date().getTime())) {
              _context.next = 8;
              break;
            }
            return _context.abrupt("return", null);
          case 8:
            // Only record earliest event if a new session was created, otherwise it
            // shouldn't be relevant
            earliestEvent = replay.getContext().earliestEvent;
            if (replay.session && replay.session.segmentId === 0 && (!earliestEvent || timestampInMs < earliestEvent)) {
              replay.getContext().earliestEvent = timestampInMs;
            }
            return _context.abrupt("return", replay.eventBuffer.addEvent(event, isCheckout));
          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _addEvent.apply(this, arguments);
}
export { addEvent };